import React from 'react';

interface StatusBadgeProps {
  status: string;
}

const STATUS_CONFIG: { [key: string]: { label: string; class: string; spinner?: boolean } } = {
  uploaded: { label: 'upload', class: 'bg-gray-100 text-gray-600' },
  processing: { label: 'en cours', class: 'bg-blue-100 text-blue-800', spinner: true },
  extracted: { label: 'extrait', class: 'bg-green-100 text-green-800' },
  completed: { label: 'extrait', class: 'bg-green-100 text-green-800' },
  pending_validation: { label: 'en validation', class: 'bg-amber-100 text-amber-800' },
  validated: { label: 'validé', class: 'bg-emerald-100 text-emerald-800' },
  error: { label: 'échoué', class: 'bg-red-100 text-red-800' },
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const config = STATUS_CONFIG[status] || { label: status, class: 'bg-gray-100 text-gray-800' };

  return (
    <span className={`px-2 py-1 rounded-full text-xs font-medium inline-flex items-center gap-1 ${config.class}`}>
      {config.spinner && (
        <svg className="animate-spin h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      )}
      {config.label}
    </span>
  );
};

export default StatusBadge;
